import React, {useState, useEffect} from 'react';
import * as S from './Login.styles';
import * as C from '../../../Common.styles';
import IconSelector from '@ibibo/icon-selector';
import {validations} from '../../../../../../utils/validations';
import {sendEvarData} from '@ibibo/analytics';
import ButtonLoader from '../../../../UI/Loader/Loader';
import {NON_EDITABLE_STATUS} from '../../../../../../constants';
import {userSelector} from 'user-reducer/src';

const Login = ({userNumber, onSubmit, apiError, status, setLoader, directLanding, btnDisable}) => {
  const [{country_code, mobile}, setUserNumberInfo] = useState({
    mobile: userNumber.mobile || '',
    country_code: '91',
  });

  const [apiErrorMsg, setApiError] = useState(apiError);
  const [errors, setError] = useState({});
  const [btnDisabled, setBtnDisabled] = useState(true);

  useEffect(() => {
    setApiError(apiError);
  }, [apiError]);

  useEffect(() => {
    setUserNumberInfo({
      mobile: userNumber.mobile || mobile,
      country_code: '91',
    });
  }, [directLanding]);

  const fieldValidators = {
    mobile: {
      field: 'mobile',
      fieldName: 'Mobile Number',
      validators: ['required', 'validMobileNumber'],
    },
    country_code: {
      field: 'mobilecode',
      fieldName: 'Mobile Code',
      validators: ['required', 'validMobileCode'],
    },
  };

  const validateFields = data => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName,
            countryCode: country_code,
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  };

  const onChangeHandler = (field, value) => {
    if (field === 'mobile') {
      const re = /^[0-9]+$/;
      if (value !== '' && !re.test(value)) {
        return;
      }
    }
    const data = {
      mobile,
      country_code,
    };
    data[field] = value;
    setUserNumberInfo(data);
  };

  useEffect(() => {
    if (mobile.length === 10) {
      setBtnDisabled(false);
    }
  }, [onChangeHandler]);

  const submitUserNumber = (event: React.FormEvent) => {
    event.preventDefault();
    const data = {
      country_code,
      mobile,
    };
    const hasError = validateFields(data);
    if (!hasError) {
      onSubmit(data);
    }

    sendEvarData(
      {
        prop54: 'myPartner|signup|personalDetails|next',
      },
      true,
    );
  };

  return (
    <S.LoginMainWrap>
      <S.LoginWrap>
        <S.LoginHeadText>Get Started</S.LoginHeadText>
        <S.LoginSubText>Log in or create an account using your mobile number</S.LoginSubText>
        <C.UserInfoForm onSubmit={submitUserNumber}>
          <S.LoginInputWrap hasError={errors['mobile'] ? true : false}>
            <IconSelector iconKey="india" />
            <S.LoginPrefix>+91</S.LoginPrefix>
            <S.TextInput
              type="text"
              placeholder="Enter Mobile Number"
              name="mobile"
              maxLength="10"
              value={mobile}
              onChange={event => onChangeHandler('mobile', event.target.value)}
              hasError={errors['mobile'] ? true : false}
            />
          </S.LoginInputWrap>
          <C.ErrorText>{errors['mobile']}</C.ErrorText>
          <C.ApiErrorText>
            {apiErrorMsg && apiErrorMsg.screen === 'home' ? apiErrorMsg.msg : ''}
          </C.ApiErrorText>
          <S.LoginButtonWrap>
            <C.ContinueButton type="submit" disabled={btnDisabled}>
              {setLoader ? <ButtonLoader loaderType="button" /> : 'Continue'}
            </C.ContinueButton>
          </S.LoginButtonWrap>
        </C.UserInfoForm>
        <S.LoginTermsWrap>
          {/* <S.LoginTermsText>By proceeding, you agree to MakeMyTrip's T&Cs and Privacy</S.LoginTermsText> */}
        </S.LoginTermsWrap>
      </S.LoginWrap>
      <S.OfferWrap>
        <S.TopBorder />
        <S.SpecialTag>Special Offer</S.SpecialTag>
        <S.OfferTextWrap>
          <S.OfferHeadText>Earn Promo Cash* on Every Booking!</S.OfferHeadText>
          <S.OfferSubText>Limited time offer on flight & hotel bookings</S.OfferSubText>
        </S.OfferTextWrap>
      </S.OfferWrap>
    </S.LoginMainWrap>
  );
};

export default Login;
